
import { uuid, uuid8 } from "./randomId"

import { debounce } from "./debounce"

function isFunction( obj ) {
  return typeof obj === "function" && typeof obj.nodeType !== "number";
}
function isPlainObject( obj ) {
  let proto, Ctor;

  let getProto = Object.getPrototypeOf;

  let class2type = {};

  let toString = class2type.toString;

  let hasOwn = class2type.hasOwnProperty;

  let fnToString = hasOwn.toString;

  let ObjectFunctionString = fnToString.call( Object );

  if ( !obj || toString.call( obj ) !== "[object Object]" ) {
    return false;
  }

  proto = getProto( obj );

  if ( !proto ) {
    return true;
  }

  Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
  return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
}
function merge(){
  let options, name, src, copy, copyIsArray, clone,
      target = arguments[ 0 ] || {},
      i = 1,
      length = arguments.length,
      deep = false;

  if ( typeof target === "boolean" ) {
    deep = target;

    target = arguments[ i ] || {};
    i++;
  }

  if ( typeof target !== "object" && !isFunction( target ) ) {
    target = {};
  }

  if ( i === length ) {
    target = this;
    i--;
  }

  for ( ; i < length; i++ ) {

    if ( ( options = arguments[ i ] ) != null ) {

      for ( name in options ) {
        if (!options.hasOwnProperty(name)) {
          continue;
        }

        src = target[ name ];
        copy = options[ name ];

        if ( target === copy ) {
          continue;
        }

        if ( deep && copy && ( isPlainObject( copy ) ||
            ( copyIsArray = Array.isArray( copy ) ) ) ) {

          if ( copyIsArray ) {
            copyIsArray = false;
            clone = src && Array.isArray( src ) ? src : [];

          } else {
            clone = src && isPlainObject( src ) ? src : {};
          }

          target[ name ] = merge( deep, clone, copy );

        } else if ( copy !== undefined ) {
          target[ name ] = copy;
        }
      }
    }
  }
  return target;
}

function addParamsToUrl(url, params) {
  if (params === undefined || params === null) {
    return url;
  }
  let index = url.indexOf('?');
  let prefix = '';
  if (index === - 1) {
    prefix = '?';
  } else if (index === url.length - 1) {
    prefix = '';
  } else {
    prefix = '&';
  }
  let urlParams = [];
  for (let key in params) {
    if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null && String(params[key]).trim() !== '') {
      urlParams.push(key + '=' + encodeURIComponent(params[key]));
    }
  }
  url += prefix + urlParams.join('&');
  return url;
}

export { 
    merge, isPlainObject, isFunction, 
    uuid, uuid8,
    debounce, addParamsToUrl
}
